export default "__VITE_ASSET__ExJ0OJ_C__"